import { createClient } from '@dolcevia/lib/supabase/client';
import { useQueries } from '@tanstack/react-query';

export const useMapPointOfInterests = () => {
  const supabase = createClient();

  const [{ data, isFetching }, { data: activities }] = useQueries({
    queries: [
      {
        queryKey: ['villages'],
        queryFn: async () => {
          const { data, error } = await supabase
            .from('beautiful_village')
            .select('lat, lng, name, image');
          if (error) return [];
          return data;
        },
      },
      {
        queryKey: ['activities'],
        queryFn: async () => {
          const { data, error } = await supabase
            .from('activities')
            .select('coordinates, title, url, image');
          if (error) return [];
          return data;
        },
      },
    ],
  });
  return { data, isFetching, activities };
};
